import React from 'react';
import { Square, Stack } from '@grubhubprod/gh-cookbook-react';
import PageHeader from 'src/components/enterprise/layout/PageHeader';
import { PageTitle } from 'src/components/enterprise/layout/PageTitle/PageTitle';
import { ReportsTable } from 'src/components/enterprise/features/Reporting/ManageReportsPage/components/ReportsTable/ReportsTable';

export const ManageReportsPage: React.FC = () => (
  <Square inset="lg">
    <Stack y="lg">
      <PageHeader>
        <PageTitle title="Reports" />
      </PageHeader>
      <ReportsTable />
    </Stack>
  </Square>
);
